











































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch, Prop } from 'vue-property-decorator';
import { Process } from '@attensi/api-js';

import { Filter } from '../../../types/ProcessTypes';

@Component
export default class ProcessListElement extends Vue {
  @Prop() process!: Process;

  active: boolean = false;
  show: boolean = true;
  loading: boolean = false;

  @Action('processModule/setActiveProcess') setActiveProcess!: Function;

  @Getter('processModule/activeProcessId') activeProcessId!: string;
  @Getter('processModule/filter') filter!: Filter;
  @Getter('processModule/isViewProcessing') isViewProcessing!: boolean;

  @Watch('activeProcessId')
  onActiveProcessIdChanged() {
    if (!this.activeProcessId || this.process.id !== this.activeProcessId) {
      this.active = false;
    } else {
      this.active = true;
    }
    this.loading = false;
  }

  @Watch('filter', { deep: true })
  onFilterChanged() {
    this.checkFilter();
  }


  async selectProcess() {
    try {

      const id = this.process.id;
      this.loading = true;
      const processResponse = await this.$creator.getProcessById(this.process.id);
      this.setActiveProcess(processResponse.data);

    } catch  {
      this.loading = false;
      throw Error(`Error getting process with id: ${this.process.id}`);
    }
  }
  checkFilter() {
    if (this.active) {
      return;
    }
    if (
      this.filter.category !== 'All' &&
      this.process.category !== this.filter.category
    ) {
      this.show = false;
      return;
    }

    if (!this.filter || !this.filter.requiredWords) {
      throw Error('No filter and/or required words!');
    }

    const content = `${this.process.title} ${this.process.category}`.toLowerCase();
    const contentHasAllRequiredWords = this.filter.requiredWords.every(
      (word: string) => content.includes(word.toLowerCase()),
    );

    this.show = contentHasAllRequiredWords ? true : false;
  }
}
